import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    initializeBlock = function() {

        // sliders
        var splideElements = document.querySelectorAll('.reviews-slider__slider.splide');

        if (splideElements.length > 0) {
            splideElements.forEach(function (splideElement) {
                var options = JSON.parse(splideElement.getAttribute('data-splide'));
                var splide = new Splide(splideElement, options);

                // pega a lista de autores do bloco pai
                var block = splideElement.closest('.reviews-slider');
                var authors = block ? block.querySelectorAll('.reviews-slider__authors .name') : [];

                // função para marcar autor ativo
                function setActiveAuthor(index) {
                    if (!authors.length) return;
                    authors.forEach((el, i) => {
                        el.classList.toggle('is-active', i === index);
                    });
                }

                // ao iniciar e ao mudar de slide
                splide.on('mounted move', function () {
                    setActiveAuthor(splide.index);
                });

                // clique no nome = navega para o slide
                if (authors.length) {
                    authors.forEach((el, i) => {
                        el.addEventListener('click', () => splide.go(i));
                    });
                }

                splide.mount();
            });
        }
    }
    
    if( window.acf ) {
        // Initialize dynamic block preview (editor).
        window.acf.addAction( 'render_block_preview/type=reviews-slider', initializeBlock );
    } else {
        // Initialize on the frontend.
        initializeBlock();
    }
});